import React, { useState, useEffect } from 'react';
import { useSwipeable } from 'react-swipeable';
import { useNavigate } from 'react-router-dom';
import { logData } from '../../../Services/APIs/scan';
const PrivacyPolicy = ({ onAccept, onClose }) => {
    const navigate = useNavigate();
    const [isChecked, setIsChecked] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    const uid = JSON.parse(localStorage.getItem("usertpi")|| "{}").usertpi;
    useEffect(() => {
        // Animate in
        setIsAnimating(true);
    }, []);

    const handleClose = () => {
        setIsAnimating(false);
        setTimeout(onClose, 300); // Call onClose after animation
    };

    const handleAccept = () => {
        localStorage.setItem("privacyAccepted", true);
        logData({ uid, message: "accepted privacy policy", company: "yves" })
        navigate('/unilever/usage-instructions');
    }

    const handlers = useSwipeable({
        onSwipedDown: () => handleClose(),
        preventScrollOnSwipe: true,
        trackMouse: true
    });

    return (
        <div
            className={`fixed inset-0 bg-black bg-opacity-50 flex items-end z-50 transition-opacity duration-300 ${isAnimating ? 'opacity-100' : 'opacity-0'
                }`}
            onClick={handleClose}
        >
            <div
                {...handlers}
                className={`w-full h-[88vh] bg-white rounded-t-2xl p-6 flex flex-col transform transition-transform duration-300 ${isAnimating ? 'translate-y-0' : 'translate-y-full'
                    }`}
                onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the panel
            >
                <div className="w-16 h-1.5 bg-gray-300 rounded-full mx-auto mb-4" />
                <h2 className="text-3xl mb-4 text-[#101928] font-CirceRounded-Regular font-semibold md:text-4xl">Pemberitahuan Privasi</h2>
                <div className="flex-grow overflow-y-auto text-[#1D273A] font-CirceRounded-Regular md:text-xl">
                    <p className='font-semibold mb-2 md:text-xl'>
                        FOTO ANDA TIDAK AKAN DISIMPAN
                    </p>
                    <p className='mb-5'>
                        ShadeScan AI adalah pengalaman yang didukung oleh Kecerdasan Buatan (AI). 
                        Hasil ini dibuat dengan Kecerdasan Buatan (AI) dan dapat bervariasi berdasarkan penggunaan individu. 
                        Hasilnya mungkin berbeda-beda tergantung kondisi gigi masing-masing individu, cara penggunaan produk dan kualitas gambar yang masuk serta kondisi pencahayaan. 
                        Harap baca petunjuk penggunaan pada kemasan
                    </p>
                    <p className='mb-5'>
                        Kami tidak akan pernah menyimpan foto Anda. 
                        Kamu harus berusia di atas 18 tahun untuk menggunakan layanan ini. 
                        Kami hanya menggunakan data yang anda untuk memberikan ilustrasi hasil penggunaan yang optimal. 
                        Kami tidak akan menyimpan fotomu. 
                        Foto ini digunakan hanya secara eksklusif untuk melakukan ilustrasi hasil penggunaan dan tidak akan disimpan. 
                        Foto Anda hanya digunakan untuk ilustrasi hasil penggunaan dan akan segera dihapus setelahnya.
                    </p>
                    <p className='mb-5'>
                        Penggunaan situs web ini diatur oleh <a href='https://www.unilever.co.id/legal/' target='_blank' rel='noopener noreferrer' title='Buka Syarat & Ketentuan' className='text-black font-bold underline'>Syarat & ketentuan</a> kami sesuai dengan <a href='https://www.unilevernotices.com/privacy-notices/indonesia-bahasa.html' target='_blank' rel='noopener noreferrer' title='Buka Pemberitahuan Privasi' className='text-black font-bold underline'>Pemberitahuan Privasi</a>
                    </p>
                    
                </div>
                <div className="mt-6">
                    <div className="flex items-center mb-4">
                        <input
                            type="checkbox" 
                            id="privacy-checkbox"
                            checked={isChecked}
                            onChange={() => setIsChecked(!isChecked)}
                            className="h-5 w-5 md:h-6 md:w-6 md:me-2 text-[#D50026] border-gray-300 rounded focus:ring-[#D50026]"
                        />
                        <label htmlFor="privacy-checkbox" className="ml-2 text-[#1D273A] font-CirceRounded-Regular md:text-xl">
                            Saya memahami dan menerima informasi yang di berikan dan <a href='https://www.unilevernotices.com/cookie-notices/indonesia-bahasa.html' target='_blank' rel='noopener noreferrer' title='Buka Kebijakan Privasi Unilever' className='text-black font-bold underline'>Kebijakan Privasi Unilever</a>.
                        </label>
                    </div>
                    <button
                        onClick={handleAccept}
                        disabled={!isChecked}
                        className={`w-full py-3 rounded-full text-lg font-semibold md:text-xl md:h-16 ${isChecked
                            ? 'bg-[#D50026] text-white'
                            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            }`}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
